import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: "0 15px 40px 15px",
  },
  "& .MuiDialog-paper": {
    margin: theme.spacing(3),
    borderRadius: "var(--dialog-border-radius)",
  },
}));

export default function CustomizedDialogs({ isOpen, setIsOpen, redirectToAnotherPage = () => {}, phone = "" }) {
  const { t } = useTranslation();
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={isOpen} sx={{ p: 0 }}>
      <Box className="phone-dialog-header">
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            color: "var(--darkblue)",
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
          id="customized-dialog-title"
        >
          {/* <img src={oldPhone} alt="oldPhone" className="phone-dialog-img" /> */}
          <Typography
            // gutterBottom
            sx={{
              fontFamily: `var(--font-family) !important`,
              fontSize: "24px",
              m: 0,
              // pb: 0,
              color: "var(--darkblue)",
              fontWeight: "700",
            }}
          >
            {t("PHONE_DIALOG.TITLE")}
          </Typography>
        </DialogTitle>
      </Box>
      <DialogContent sx={{ direction: "rtl" }}>
        <Typography
          gutterBottom
          sx={{
            fontSize: "16px",
            fontFamily: `var(--font-family) !important`,
          }}
        >
          {t("PHONE_DIALOG.INSTRUCTION")}
          <span style={{ fontWeight: 700, color: "var(--darkblue)" }}>״{t("PHONE_DIALOG.CONFIRMED")}״.</span>
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 0, m: 0 }}>
        <Button sx={{ py: "16px", whiteSpace: "nowrap" }} variant="contained" className="phone-dialog-contact-btn">
          <a href={`tel:+${phone.split("-").join("")}`} style={{ color: "white", textDecoration: "none" }}>
            {t("PHONE_DIALOG.CONTACT")}
          </a>
        </Button>
        <Button
          sx={{ py: "16px", whiteSpace: "nowrap" }}
          variant="contained"
          className="phone-dialog-scheduled-btn"
          onClick={() => {
            handleClose();
            redirectToAnotherPage();
          }}
        >
          {t("PHONE_DIALOG.CONFIRMED")}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
